import { addAllToRecord } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { DeleteMessageFulfilledAction } from '../../../domains/deleteMessage/actions.types';
import type { DeleteThreadFulfilledAction } from '../../../domains/deleteThread/actions.types';
import type {
  FeedLoadFulfilledAction,
  FeedLoadNewerThreadsFulfilledAction,
  FeedLoadOlderThreadsFulfilledAction,
} from '../../../domains/feedLoad/actions.types';
import type {
  ThreadPinToCampaignFeedFulfilledAction,
  ThreadUnpinFromCampaignFeedFulfilledAction,
} from '../../../domains/pinnedThreads/actions.types';
import type { ThreadMoveCompletedAction } from '../../../domains/threadMove/actions.types';
import {
  removeThreadFromAnyPinnedInstance,
  removeThreadFromAnyPinnedInstanceIfDeleted,
} from '../removeDeletedPinnedThread';
import type { ThreadsPinnedToFeeds } from '../types';
export type ThreadsPinnedToCampaignFeedsAction =
  | DeleteMessageFulfilledAction
  | DeleteThreadFulfilledAction
  | FeedLoadFulfilledAction
  | FeedLoadNewerThreadsFulfilledAction
  | FeedLoadOlderThreadsFulfilledAction
  | ThreadMoveCompletedAction
  | ThreadPinToCampaignFeedFulfilledAction
  | ThreadUnpinFromCampaignFeedFulfilledAction;
const initialState: ThreadsPinnedToFeeds = {};
const reducer: Reducer<ThreadsPinnedToFeeds, ThreadsPinnedToCampaignFeedsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEED.LOAD_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToCampaignFeeds);
    case 'FEED.LOAD_OLDER_THREADS_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToCampaignFeeds);
    case 'FEED.LOAD_NEWER_THREADS_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToCampaignFeeds);
    case 'THREAD.PIN_TO_CAMPAIGN_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToCampaignFeeds);
    case 'THREAD.UNPIN_FROM_CAMPAIGN_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToCampaignFeeds);
    case 'MESSAGE.DELETE_FULFILLED':
      return removeThreadFromAnyPinnedInstanceIfDeleted(
        state,
        action.payload.threadId,
        action.payload.deletionOutcome === 'THREAD_REMOVED'
      );
    case 'THREAD.DELETE_FULFILLED':
      return removeThreadFromAnyPinnedInstance(state, action.payload.threadId);
    case 'THREAD.MOVE_COMPLETED':
      return removeThreadFromAnyPinnedInstance(state, action.payload.threadId);
    default:
      return state;
  }
};
export default reducer;
